import type { FC } from "react";
import type { Currency } from "../../../data/BaseEntity";
import { Price } from "../../../misc/price";
import ProductsTotalPrice from "./ProductsTotalPrice";
import SurroundingDaysPrice from "./SurroundingDaysPrice";
import type { CalculationProductWithPrices } from "../useProductsWithPrices";

interface Props {
  readonly calculationProducts: Omit<CalculationProductWithPrices, "optional">[];
  readonly availableProducts: { id: string; currency: Currency }[];
  readonly currency: Currency | undefined;
  readonly margin: number;
  readonly numberOfPeople: number;
}

function productPricesSum(products: { price: Price }[]) {
  return products.reduce((prev, curr) => prev.add(curr.price), new Price(0));
}

const ProductsPriceSummary: FC<Props> = ({
  calculationProducts,
  availableProducts,
  currency,
  margin,
  numberOfPeople,
}) => {
  return (
    <SurroundingDaysPrice
      selectedProducts={calculationProducts}
      availableProducts={availableProducts}
      currency={currency}
      margin={margin}
      numberOfPeople={numberOfPeople}
    >
      <ProductsTotalPrice
        price={productPricesSum(calculationProducts)}
        currency={currency}
        numberOfPeople={numberOfPeople}
      />
    </SurroundingDaysPrice>
  );
};

export default ProductsPriceSummary;
